export default [
    {
        path: "consultorias/expediente-consultores",
        name: "expediente-consultores",
        component: () =>
            import(/* webpackChunkName: "expedienteConsultores" */ "../expediente-consultores/views/expedienteConsultores.vue"),
    },
    {
        path: "consultorias/consultores-asignados",
        name: "consultores-asignados",
        component: () =>
            import(/* webpackChunkName: "expedienteConsultores" */ "../expediente-consultores/views/expedienteConsultores.vue"),
    },
    {
        path: "consultorias/registrar-consultor",
        name: "registrar-consultor",
        component: () =>
            import(/* webpackChunkName: "registrarConsultor" */ "../expediente-consultores/views/registrarConsultor.vue"),
    },
    {
        path: "consultorias/expediente-consultores/historial-consultoria/:id?",
        name: "historial-consultoria-consultor",
        component: () =>
            import(/* webpackChunkName: "historialConsultoria" */ "../expediente-consultores/views/historialConsultoria.vue"),
    },
    {
        path: "consultorias/expediente-consultores/ver-expediente/:id?",
        name: "ver-expediente",
        component: () =>
            import(/* webpackChunkName: "verExpediente" */ "../expediente-consultores/views/verExpediente.vue"),
    },
]
